import { render, staticRenderFns } from "./VMultiCarousel.vue?vue&type=template&id=851bd92a&scoped=true"
import script from "./VMultiCarousel.vue?vue&type=script&lang=ts"
export * from "./VMultiCarousel.vue?vue&type=script&lang=ts"
import style0 from "./VMultiCarousel.vue?vue&type=style&index=0&id=851bd92a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851bd92a",
  null
  
)

export default component.exports